import React, { useState, useEffect } from 'react'
import DeckGL, { FlyToInterpolator } from 'deck.gl'
import { useDispatch, useSelector } from 'react-redux'
import { ViewMode } from '@nebula.gl/edit-modes'
import { v4 as uuidv4 } from 'uuid'

import AWS from 'aws-sdk'

import CloseIcon from '@material-ui/icons/Close'
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined'
import ExpandLessOutlinedIcon from '@material-ui/icons/ExpandLessOutlined'
import CreateNewFolderOutlinedIcon from '@material-ui/icons/CreateNewFolderOutlined'
import FolderOutlinedIcon from '@material-ui/icons/FolderOutlined'
import GetAppIcon from '@material-ui/icons/GetApp'
import PublishIcon from '@material-ui/icons/Publish'
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined'
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined'
import MenuIcon from '@material-ui/icons/Menu'
import CloudQueueIcon from '@material-ui/icons/CloudQueue'

import Grow from '@material-ui/core/Grow'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import Modal from '@material-ui/core/Modal'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Popover from '@material-ui/core/Popover'

import PointIcon from '../../../../assets/coordinates.png'
import LineIcon from '../../../../assets/line.png'
import PolygonIcon from '../../../../assets/shape.png'

import DownloadModal from './ModalComponents/DownloadModal'
import AddModal from './ModalComponents/AddModal'
import RenameModal from './ModalComponents/RenameModal'
import DeleteModal from './ModalComponents/DeleteModal'
import ImportModal from './ModalComponents/ImportModal'
import SavedFiles from './DownloadFiles/SavedFiles'
import UploadModal from './ModalComponents/UploadModal'

import { setFilesInfo } from 'store/global/map/filesMenuInfo'

import './filesMenu.css'

function FilesMenu(props) {
  const dispatch = useDispatch()
  const filesMenuInfo = useSelector((state) => state.filesMenuInfo)

  const [downloadModal, setDownloadModal] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [anchorGeom, setAnchorGeom] = useState(null)
  const [anchorCopy, setAnchorCopy] = React.useState(null)
  const [renameModal, setRenameModal] = useState(false)
  const [addModal, setAddModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [importModal, setImportModal] = useState(false)
  const [downloadCloudModal, setDownloadCloudModal] = useState(false)
  const [uploadModal, setUploadModal] = useState(false)

  const [folderId, setFolderId] = useState('')
  const [currentProject, setCurrentProject] = useState({
    projectName: '',
    visible: false,
    active: false,
    height: false,
    s3: false,
  })
  const [change, setChange] = useState(0)
  const [projects, setProjects] = useState([
    { project_id: uuidv4(), projectName: 'Project A', visible: true, active: false, height: true, s3: false },
  ])
  const [geometry, setGeometry] = useState()

  useEffect(() => {
    if (filesMenuInfo.data.length > 0) {
      // setProjects(filesMenuInfo.data)
      let currentProjectsStoredJSON = JSON.parse(JSON.stringify(filesMenuInfo.data))
      let currentProjectsInitialViewState = [...currentProjectsStoredJSON]
      setProjects((initialViewState) => currentProjectsInitialViewState)
    }
  }, [])

  useEffect(() => {
    // console.log(projects)
    let currentProjectsInfoStoredJSON = JSON.parse(JSON.stringify(projects))
    let currentProjectsInfo = [...currentProjectsInfoStoredJSON]
    dispatch(setFilesInfo(currentProjectsInfo))
    // return () => {
    //   socket.disconnect();
    // };
  }, [projects])

  const buttons = [
    { lbl: 'AddFolder', icon: <CreateNewFolderOutlinedIcon />, onClick: () => handleAddModal(true) },
    { lbl: 'Import', icon: <PublishIcon />, onClick: () => setImportModal(true) },
    { lbl: 'Export', icon: <GetAppIcon />, onClick: () => setDownloadModal(true) },
    { lbl: 'Load', icon: <CloudQueueIcon />, onClick: () => setDownloadCloudModal(true) },
  ]

  const setProject = (projectName) => {
    props.setActiveProject(projectName)
  }

  const handleAddModal = () => {
    const toggle = projects
    toggle.map((folder) => {
      folder.active = false
    })
    setProjects(toggle)
    setAddModal(true)
  }

  const handleCloseModal = () => {
    const toggle = projects
    toggle[0].active = true
    setProjects(toggle)
    props.setActiveProject(toggle[0].projectName)
    setAddModal(false)
  }

  const setProjectActive = (projectName) => {
    const toggle = projects
    toggle.map((folder) => {
      folder.active = false
      if (folder.projectName === projectName) {
        folder.active ? (folder.active = false) : (folder.active = true)
      }
    })
    setProjects(toggle)
    props.setActiveProject(projectName)
  }

  const expand = (projectName) => {
    // console.log(projectName)
    const toggle2 = projects
    toggle2.map((folder) => {
      if (folder.projectName === projectName) {
        folder.height ? (folder.height = false) : (folder.height = true)
      }
    })
    setProjects(toggle2)
    setChange(Math.random())
  }

  const hide = (projectName, bool) => {
    const features = props.features
    features.features.map((data) => {
      if (data.properties.id === projectName) {
        data.properties.show = bool ? 0 : 1
      }
    })
    props.setFeatures(features)

    const toggle = projects
    toggle.map((folder) => {
      if (folder.projectName === projectName) {
        folder.visible ? (folder.visible = false) : (folder.visible = true)
      }
    })
    setProjects(toggle)

    props.setColorChange(Math.random())
  }

  const hideSingle = (coordinates, bool) => {
    const features = props.features
    features.features.map((data) => {
      if (data.geometry.coordinates === coordinates) {
        data.properties.show = bool ? 0 : 1
      }
    })
    props.setFeatures(features)
    props.setColorChange(Math.random())
  }

  const addFeatures = (newFeatures) => {
    // console.log(newFeatures)
    // setProjects((prevState) => {
    //     return [...prevState, { projectName: id, visible: true, active: false, height: true }]
    //   })
    props.setFeatures({
      type: 'FeatureCollection',
      features: props.features.features.concat(newFeatures),
      // .filter(
      //   (ftr) =>
      //     ftr.geometry.type !== 'GeometryCollection' &&
      //     ftr.geometry.type !== 'MultiPoint' &&
      //     ftr.geometry.type !== 'MultiLineString' &&
      //     ftr.geometry.type !== 'MultiPolygon',
      // )
    })
    props.setColorChange(Math.random())
  }

  const deleteFeatures = (newFeatures) => {
    const filtro = props.features.features.filter((val) => val.properties.id !== folderId)
    props.setFeatures({
      type: 'FeatureCollection',
      features: filtro,
    })
    props.setColorChange(Math.random())
    // console.log(newFeatures)
  }

  const findGeometry = () => {
    const { type, coordinates } = geometry.geometry
    const location =
      type === 'MultiPolygon' || type === 'MultiLineString' || type === 'MultiPoint' || type === 'GeometryCollection'
        ? coordinates[0][0][0]
        : type === 'Polygon'
        ? coordinates[0][0]
        : type === 'LineString'
        ? coordinates[0]
        : coordinates
    props.setInitialViewState({
      longitude: location[0],
      latitude: location[1],
      zoom: 14,
      pitch: 0,
      bearing: 0,
      transitionDuration: 4000,
      transitionInterpolator: new FlyToInterpolator(),
    })
    // console.log(type)
    // console.log(coordinates)
  }

  return (
    <Grow in={props.files}>
      <div id="Files-menu-container" className="files-menu">
        <Modal
          open={downloadModal}
          // onClose={() => setDownloadModal(false)}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ display: 'flex' }}
        >
          <DownloadModal setDownloadModal={setDownloadModal} features={props.features} projects={projects} />
        </Modal>
        <Modal
          open={addModal}
          // onClose={() => setAddModal(false)}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ display: 'flex' }}
        >
          <AddModal
            setAddModal={setAddModal}
            handleCloseModal={handleCloseModal}
            setProjects={setProjects}
            setProject={setProject}
          />
        </Modal>
        <Modal
          open={renameModal}
          // onClose={() => setAddModal(false)}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ display: 'flex' }}
        >
          <RenameModal
            setRenameModal={setRenameModal}
            features={props.features}
            projects={projects}
            setProjects={setProjects}
            setProject={setProject}
            folderId={folderId}
          />
        </Modal>
        <Modal
          open={deleteModal}
          // onClose={() => setAddModal(false)}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ display: 'flex' }}
        >
          <DeleteModal
            setDeleteModal={setDeleteModal}
            features={props.features}
            projects={projects}
            setProjects={setProjects}
            setProject={setProject}
            folderId={folderId}
            deleteFeatures={deleteFeatures}
          />
        </Modal>
        <Modal
          open={importModal}
          // onClose={() => setAddModal(false)}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ display: 'flex' }}
        >
          <ImportModal
            setImportModal={setImportModal}
            features={props.features}
            projects={projects}
            setProjects={setProjects}
            setProject={setProject}
            folderId={folderId}
            addFeatures={addFeatures}
            deleteFeatures={deleteFeatures}
          />
        </Modal>

        <Modal
          open={downloadCloudModal}
          onClose={() => setDownloadCloudModal(false)}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ display: 'flex' }}
        >
          {/*<DownloadCloudModal*/}
          <SavedFiles
            setDownloadCloudModal={setDownloadCloudModal}
            // fileList={props.fileList}
            // setFileList={props.setFileList}
            features={props.features}
            setFeatures={props.setFeatures}
            projects={projects}
            setProjects={setProjects}
            addFeatures={addFeatures}
          />
        </Modal>

        <Modal open={uploadModal} onClose={() => setUploadModal(false)} style={{ display: 'flex' }}>
          <UploadModal
            setRenameModal={setRenameModal}
            setUploadModal={setUploadModal}
            features={props.features}
            projects={projects}
            setProjects={setProjects}
            setProject={setProject}
            folderId={folderId}
            currentProject={currentProject}
            deleteFeatures={deleteFeatures}
          />
        </Modal>

        <div style={{ color: 'black', height: '20px', display: 'flex' }}>
          <label className="on-click-title">Files</label>
          <CloseIcon
            style={{
              fontSize: '19px',
              position: 'relative',
              margin: 'auto',
              marginRight: '5px',
              cursor: 'pointer',
            }}
            onClick={() => props.setFiles(false)}
          />
        </div>
        <div className="info-container">
          <div style={{ display: 'flex', height: '25px' }}>
            <ExpandMoreOutlinedIcon style={{ alignSelf: 'center' }} />
            <FolderOutlinedIcon style={{ alignSelf: 'center' }} />
            <label style={{ alignSelf: 'center', marginLeft: '5px' }}>Projects</label>
          </div>

          {projects.map((data) => (
            <div
              style={
                data.height ? { height: 'fit-content', overflow: 'hidden' } : { height: '25px', overflow: 'hidden' }
              }
            >
              <div className="files-folder-container" style={data.active ? { background: '#ccc' } : null}>
                {data.height ? (
                  <ExpandLessOutlinedIcon className="files-arrow" onClick={() => expand(data.projectName)} />
                ) : (
                  <ExpandMoreOutlinedIcon className="files-arrow" onClick={() => expand(data.projectName)} />
                )}
                {data.visible ? (
                  <VisibilityOutlinedIcon
                    className="files-visibility-btn"
                    onClick={() => hide(data.projectName, data.visible)}
                  />
                ) : (
                  <VisibilityOffOutlinedIcon
                    className="files-visibility-btn"
                    style={{ opacity: 0.5 }}
                    onClick={() => hide(data.projectName, data.visible)}
                  />
                )}
                <Tooltip title={data.projectName} placement="top" arrow>
                  <div className="files-toggle" onClick={() => setProjectActive(data.projectName)}>
                    <FolderOutlinedIcon
                      style={{ alignSelf: 'center', cursor: 'pointer' }}
                      // onClick={() => setProjectActive(data.projectName)}
                    />
                    <label
                      className="files-menu-lbl"
                      // onClick={() => setProjectActive(data.projectName)}
                    >
                      {data.projectName}
                    </label>
                  </div>
                </Tooltip>
                {/*data.visible ? (
                  <VisibilityOutlinedIcon
                    className="files-visibility-btn"
                    onClick={() => hide(data.projectName, data.visible)}
                  />
                ) : (
                  <VisibilityOffOutlinedIcon
                    className="files-visibility-btn"
                    style={{ opacity: 0.5 }}
                    onClick={() => hide(data.projectName, data.visible)}
                  />
                )*/}
                <IconButton
                  size="small"
                  component="span"
                  onClick={(event) => {
                    setAnchorEl(event.currentTarget)
                    setCurrentProject(data)
                    setFolderId(data.projectName)
                  }}
                  style={{ margin: 'auto 0px auto auto' }}
                >
                  <MenuIcon style={{ height: '20px', width: '20px' }} />
                </IconButton>
              </div>
              {props.features.features.map((geom) =>
                geom.properties.id === data.projectName ? (
                  <div
                    className="files-geometry-click"
                    style={props.selectedGeometry === geom ? { background: '#eee' } : null}
                  >
                    {geom.properties.show === 1 ? (
                      <VisibilityOutlinedIcon
                        className="files-visibility-btn"
                        style={{ marginRight: '5px' }}
                        onClick={() => hideSingle(geom.geometry.coordinates, geom.properties.show)}
                      />
                    ) : (
                      <VisibilityOffOutlinedIcon
                        className="files-visibility-btn"
                        style={{ opacity: 0.5, marginRight: '5px' }}
                        onClick={() => hideSingle(geom.geometry.coordinates, geom.properties.show)}
                      />
                    )}
                    <div
                      className="files-geom-lbl"
                      onContextMenu={(e) => {
                        e.preventDefault()
                        props.close()
                        props.setMode(() => ViewMode)
                        setAnchorGeom(event.target)
                        setGeometry(geom)
                        props.setSelectedGeometry(geom)
                      }}
                    >
                      {geom.geometry.type === 'Point' ? (
                        <img src={PointIcon} style={{ alignSelf: 'center', height: '15px', pointerEvents: 'none' }} />
                      ) : geom.geometry.type === 'LineString' ? (
                        <img src={LineIcon} style={{ alignSelf: 'center', height: '15px', pointerEvents: 'none' }} />
                      ) : (
                        <img src={PolygonIcon} style={{ alignSelf: 'center', height: '15px', pointerEvents: 'none' }} />
                      )}
                      <label className="files-menu-lbl" style={{ pointer: 'default', pointerEvents: 'none' }}>
                        {geom.properties.name ? geom.properties.name : geom.geometry.type}
                      </label>
                    </div>
                    {/*geom.properties.show === 1 ? (
                      <VisibilityOutlinedIcon
                        className="files-visibility-btn"
                        onClick={() => hideSingle(geom.geometry.coordinates, geom.properties.show)}
                      />
                    ) : (
                      <VisibilityOffOutlinedIcon
                        className="files-visibility-btn"
                        style={{ opacity: 0.5 }}
                        onClick={() => hideSingle(geom.geometry.coordinates, geom.properties.show)}
                      />
                    )*/}
                  </div>
                ) : null,
              )}
            </div>
          ))}

          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            <MenuItem
              onClick={() => {
                setUploadModal(true)
                setAnchorEl(null)
              }}
              style={{ fontSize: '12px', fontFamily: '' }}
            >
              {currentProject.s3 ? 'Update' : 'Upload'}
            </MenuItem>
            {!currentProject.s3 ? (
              <MenuItem
                onClick={() => {
                  setRenameModal(true)
                  setAnchorEl(null)
                }}
                style={{ fontSize: '12px', fontFamily: '' }}
              >
                Rename
              </MenuItem>
            ) : null}
            <MenuItem
              onClick={() => {
                setDeleteModal(true)
                setAnchorEl(null)
              }}
              style={{ fontSize: '12px', fontFamily: '' }}
            >
              Delete
            </MenuItem>
          </Menu>

          <Menu
            id="simple-menu-2"
            style={{ marginLeft: '60px' }}
            anchorEl={anchorGeom}
            keepMounted
            open={Boolean(anchorGeom)}
            onClose={() => {
              setAnchorGeom(null)
              setGeometry()
            }}
          >
            <MenuItem
              onClick={(e) => {
                setAnchorCopy(e.currentTarget)
              }}
              style={{ fontSize: '12px', fontFamily: '' }}
            >
              Copy to...
            </MenuItem>
            <MenuItem
              onClick={() => {
                findGeometry()
                setAnchorGeom(null)
              }}
              style={{ fontSize: '12px', fontFamily: '' }}
            >
              Find
            </MenuItem>
            <MenuItem
              onClick={() => {
                props.findGeometry()
                setAnchorGeom(null)
              }}
              style={{ fontSize: '12px', fontFamily: '' }}
            >
              Edit Geometry
            </MenuItem>
            <MenuItem
              onClick={() => {
                props.propertiesGeometry()
                setAnchorGeom(null)
              }}
              style={{ fontSize: '12px', fontFamily: '' }}
            >
              Styles
            </MenuItem>
            <MenuItem
              onClick={() => {
                props.deleteGeometry()
                setAnchorGeom(null)
              }}
              style={{ fontSize: '12px', fontFamily: '' }}
            >
              Delete
            </MenuItem>
          </Menu>
          <Popover
            //id={id}
            open={Boolean(anchorCopy)}
            anchorEl={anchorCopy}
            onClose={() => setAnchorCopy(null)}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <div style={{ padding: '6px 0px', width: '190px' }}>
              {projects.map((project) => (
                <div
                  className="copy-menu-item"
                  onClick={() => {
                    setAnchorGeom(null)
                    setAnchorCopy(null)
                    props.moveGeometry(project)
                  }}
                >
                  <FolderOutlinedIcon className="copy-menu-icon" />
                  <label className="copy-menu-lbl">{project.projectName}</label>
                </div>
              ))}
            </div>
          </Popover>

          <div className="files-menu-footer">
            {buttons.map((btn) => (
              <Tooltip title={btn.lbl} placement="top" arrow>
                <IconButton
                  size="small"
                  component="span"
                  onClick={btn.onClick}
                  style={{ margin: 'auto', height: '20px', width: '20px' }}
                >
                  {btn.icon}
                </IconButton>
              </Tooltip>
            ))}
          </div>
        </div>
      </div>
    </Grow>
  )
}

export default FilesMenu
